import { i18n } from '../i18n';

/**
 * Текущий язык из i18n (ru | en).
 */
export function getCurrentLang(): 'ru' | 'en' {
  const lng = i18n.language;
  return lng === 'en' ? 'en' : 'ru';
}

/**
 * Формирует путь с языковым префиксом: /{lang}{path}.
 * path должен начинаться с / или быть пустым (тогда получится /{lang}/).
 */
export function pathWithLang(path: string): string {
  const lang = getCurrentLang();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return normalized === '/' ? `/${lang}/` : `/${lang}${normalized}`;
}

/**
 * Обновляет URL через pushState с сохранением языкового префикса.
 */
export function navigateTo(path: string): void {
  const fullPath = pathWithLang(path);
  window.history.pushState({}, '', fullPath);
}
